module.exports = __webpack_public_path__ + "assets/img/deny.e4f06193.svg";